<table class="table table-custom table-hover table-sm table-grid-responsive">
    <!--<caption></caption>-->
    <thead class="th-custom">
        <tr>
            <th class="th-grid-responsive">{{ 'rollCall.gridColumns.id' | translate }}</th>
            <th class="th-grid-responsive">{{ 'rollCall.gridColumns.idEnrollment' | translate }}</th>
            <!--
            <th class="th-grid-responsive">{{ 'rollCall.gridColumns.fullName' | translate }}</th>-->
            <th class="th-grid-responsive">{{ 'rollCall.gridColumns.fullName' | translate }}</th>
            <th class="th-grid-responsive">{{ 'rollCall.gridColumns.register' | translate }}</th>
            <th class="th-grid-responsive">{{ 'rollCall.gridColumns.location' | translate }}</th>
            <th class="th-grid-responsive">{{ 'rollCall.gridColumns.activityDate' | translate }}</th>
            <th class="th-grid-responsive">{{ 'rollCall.gridColumns.validations' | translate }}</th>
            <th class="th-grid-responsive"></th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngIf="dataInformation && dataInformation.length > 0">
            <ng-container *ngFor="let data of dataInformation">
                <tr class="tr-custom">
                    <td class="td-grid-responsive">
                        <span class="td-value-row"> {{ data.id }} </span>
                    </td>
                    <td class="td-grid-responsive">
                        <span class="td-value-row">{{ data.platformId }}</span>
                    </td>
                    <!--
                    <td class="td-grid-responsive">
                        <span class="td-value-row">Por validar</span>
                    </td>-->
                    <td class="td-grid-responsive">
                        <span class="td-value-row">{{ data.personName }}</span>
                    </td>
                    <td class="td-grid-responsive">
                        <span class="td-value-row">{{ data.name }}</span>
                    </td>

                    <td class="td-grid-responsive">
                        <ng-container *ngIf="data.source == 'provider'">
                            <span class="td-value-row">{{data.address}}</span>
                        </ng-container>
                        <ng-container *ngIf="data.source !== 'provider'">
                            <span class="td-value-row linkUbication"
                                (click)="actionEvent('viewLocation', data.geolocation)">Ver ubicación</span>
                        </ng-container>

                    </td>

                    <td class="td-grid-responsive">
                        <emi-table-date-format [dateData]="data.registrationDate"></emi-table-date-format>
                    </td>
                    <td class="td-grid-responsive">
                        <emi-validation-list-table [validationData]="data.validations"></emi-validation-list-table>
                    </td>
                    <td class="td-grid-responsive">
                        <div class="w-100 d-flex justify-all-center">
                            <!--<button [disabled]="data?.type !== 'assistance'" type="button" class="btn-none"
                                (click)="actionEvent('view', data)">
                                <mat-icon>remove_red_eye</mat-icon>
                            </button>-->
                            <button type="button" class="btn-none" (click)="actionEvent('view', data)">
                                <mat-icon>remove_red_eye</mat-icon>
                            </button>
                        </div>

                    </td>
                </tr>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="dataInformation && dataInformation.length <= 0">
            <tr class="grid-empty text-center bg-light">
                <td colspan="9" class="mt-3 h-360-px justify-all-center">
                    <img class="img-folder-empty" src="assets/images/icon/Folder.svg" alt="empty folder">
                    <br>
                    <span class="text-info-gray fw-w-bold">Sin datos</span>
                </td>
            </tr>
        </ng-container>

    </tbody>
</table>